import React, { memo, useMemo } from 'react';
import { useTableContext } from '../../context/TableContext';

/**
 * AttachmentsCell - Displays attachments count with paperclip icon
 * Clicking opens the attachments modal
 * Memoized to prevent re-renders when other cells change
 */
const AttachmentsCell = memo(({ row }) => {
  const task = row.original;
  const attachments = task.attachments || [];
  const count = attachments.length;
  const { onOpenAttachments } = useTableContext();
  
  // Memoize title text
  const titleText = useMemo(() => {
    if (count === 0) return 'No attachments';
    return attachments.map(a => a.filename || a.name || 'File').join('\n');
  }, [attachments, count]);
  
  const handleClick = (e) => {
    e.stopPropagation();
    onOpenAttachments?.(task.id);
  };

  if (count === 0) {
    return (
      <button 
        className="table-view__attachments-cell table-view__attachments-cell--empty"
        onClick={handleClick}
        title="Add attachments"
      >
        <svg 
          className="table-view__attachments-icon" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
      </button>
    );
  }

  return (
    <button 
      className="table-view__attachments-cell table-view__attachments-cell--has-files"
      onClick={handleClick}
      title={titleText}
    >
      <svg 
        className="table-view__attachments-icon" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
      </svg>
      <span className="table-view__attachments-count">{count}</span>
    </button>
  );
}, (prevProps, nextProps) => {
  const prevTask = prevProps.row.original;
  const nextTask = nextProps.row.original;
  return prevTask.id === nextTask.id && 
         prevTask.attachments === nextTask.attachments;
});

export default AttachmentsCell;
